import API from 'services/api';

export const getDashboardData = async () => {
  return await API.get(`/dashboard`);
};
